<template>
  <div class="card">
    <div class="form-title">
      <span v-if="firstPerson">Mon profil ({{ name }})</span>
      <span v-else>
        Le profil de {{ name }}
      </span>
    </div>

    <div>
      <div class="card-content">
        <div>
          <strong>Année de naissance:</strong> {{ value.year_of_birth }}
        </div>

        <div>
          <strong>Genre:</strong> {{ humanizeGender(value.gender) }}
        </div>

        <div>
          <strong>Souhaite perdre du poids:</strong> {{ value.want_to_loose_weight ? "Oui" : "Non" }}
        </div>

        <div>
          <strong>Taille:</strong> {{ value.height }} cm
        </div>

        <div>
          <strong>Poids:</strong> {{ value.weight }} kg
        </div>

        <div>
          <strong>
            Temps d'activité physique moyenne par jour
            <a href="#" class="infos"
              v-b-popover.hover.top="`Connaitre votre temps moyen d'activité physique par jour nous aide à calculer vos besoins en apport calorique`"
              title="Temps moyen d'activité physique par jour">?</a>
          </strong>
        </div>

        <div class="grid">
          <div>
            Faible intensité
            <a href="#" class="infos"
              v-b-popover.hover.top="`Exemple: Position debout, attente passive, cuisiner, travail statique...`"
              title="Temps moyen d'activité physique de faible intensité par jour">?</a>
          </div>

          <ProgressBar :value="value.low_intensity_activity" :max="8 * 60" :height="32" color="#7ab228" />

          <div>
            Intensité modérée
            <a href="#" class="infos"
              v-b-popover.hover.top="`Exemple: Industrie de production, menuiserie, yoga, marche...`"
              title="Temps moyen d'activité physique d'intensité modérée par jour">?</a>
          </div>

          <ProgressBar :value="value.medium_intensity_activity" :max="8 * 60" :height="32" color="#e7b642" />

          <div>
            Forte intensité
            <a href="#" class="infos"
              v-b-popover.hover.top="`Exemple: Travaux du bâtiment, bêchage, ménage intensif, sport en compétition, footing...`"
              title="Temps d'activité physique moyenne de forte intensité par jour">?</a>
          </div>

          <ProgressBar :value="value.high_intensity_activity" :max="8 * 60" :height="32" color="#ee5e5b" />
        </div>
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <button class="button" @click="editActivity = true" :disabled="saving || removing" style="margin-right: 10px;">
          <font-awesome-icon :icon="['fas', 'edit']" />
          Modifier
        </button>

        <button class="button" @click="remove" :disabled="saving || removing">
          <font-awesome-icon :icon="['fas', 'trash']" />
          Supprimer
        </button>
      </div>
    </div>

    <EditProfilModal v-if="editActivity" :profil="value" :firstPerson="firstPerson" @close="editActivity = false" />
  </div>
</template>

<script>
import { api } from "@/api";
import ProgressBar from "@/components/ProgressBar.vue";
import EditProfilModal from "@/components/EditProfilModal.vue";

export default {
  name: "ConsumerProfil",
  components: {
    ProgressBar,
    EditProfilModal,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    firstPerson: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: null,
      saving: false,
      removing: false,
      editActivity: false,
    };
  },
  computed: {
    name() {
      if (this.form) {
        return this.form.name || "...";
      } else if (this.value.name) {
        return this.value.name;
      } else {
        return "...";
      }
    },
  },
  mounted() {
    if (this.value.id === undefined) {
      this.edit();
    }
  },
  methods: {
    edit() {
      this.form = Object.assign({}, this.value);
      this.editActivity = true;
    },

    async remove() {
      if (!confirm("Voulez-vous vraiment supprimer ce profil ?")) return;

      this.removing = true;
      try {
        await api.delete(`/my-consumers/${this.value.id}/`);
        // ✅ N'affiche pas d'alert ici
        // ✅ Informe simplement le parent que la suppression est terminée
        this.$emit("deleted", this.value.id);
      } catch (error) {
        console.error("Erreur suppression foyer:", error);
        alert("❌ Erreur lors de la suppression du foyer");
      } finally {
        this.removing = false;
      }
    },

    humanizeGender(gender) {
      return {
        male: "Homme",
        female: "Femme",
      }[gender];
    },
  },
};
</script>



<style scoped>
.card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}


.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
}
</style>
